import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { setToken } from "../../store";

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const apiUrl = import.meta.env.VITE_API_URL;
const apiRegisterRoute = "register_user/social";
const apiLoginRoute = "login/social";

const authProvider = "google";

// This is used both for login and register
const GoogleLogInBtn = ({
  register = false,
  newsletter = false,
  setErrorMsg,
}) => {
  const apiEndpoint = `${apiUrl}${register ? apiRegisterRoute : apiLoginRoute}`;

  const dispatch = useDispatch();

  const handleSuccess = async (response) => {
    try {
      const res = await fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          token: response.credential,
          auth_provider: authProvider,
          newsletter: newsletter,
        }),
      });

      if (res.ok) {
        // The JWT is now in an HttpOnly cookie; mark the user as logged in
        dispatch(setToken());
      } else {
        const errorMsg = `Failed to log in: ${res.statusText}`;
        console.error(errorMsg);
        setErrorMsg(errorMsg);
      }
    } catch (error) {
      const errorMsg = `Error during login: ${error.message}`;
      console.error(errorMsg);
      setErrorMsg(errorMsg);
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => {
          const errorMsg = "Login Failed";
          console.log(errorMsg);
          setErrorMsg(errorMsg); // Set error message
        }}
      />
    </GoogleOAuthProvider>
  );
};

export default GoogleLogInBtn;
